import { render, staticRenderFns } from "./PracticeInfo.vue?vue&type=template&id=9d4050ea&scoped=true&"
import script from "./PracticeInfo.vue?vue&type=script&lang=ts&"
export * from "./PracticeInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeInfo.vue?vue&type=style&index=0&id=9d4050ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4050ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VForm,VSwitch,VTextField})
